import React, { useState } from "react";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { DASHBOARD_TYPE } from "src/constant/common";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

const Series6DofMCSDashboard = ({
  handleClickAscent,
  handleClickDescent,
  handleClickTrimming,
  handleClickStatistical,
  id,
  isLoading,
  isShow = true,
  serieData,
}) => {
  const { t } = useTranslation("flight-simulator");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const isDashboardReady = (type) => {
    return !!serieData?.simulator_dashboards?.filter((item) => item.dashboard_type === type)?.[0]?.dashboard_url;
  };

  const isFullDashboard =
    isDashboardReady(DASHBOARD_TYPE.ASCENT_6DOF) &&
    isDashboardReady(DASHBOARD_TYPE.DESCENT_6DOF) &&
    isDashboardReady(DASHBOARD_TYPE.MCS_6DOF_TRIMMING) &&
    isDashboardReady(DASHBOARD_TYPE.MCS_6DOF_STATISTICAL);

  return isShow ? (
    isLoading ? (
      <Spinner size="sm" color="secondary" />
    ) : (
      <TooltipWrapper tooltipText={t("list.table.dashboard")} id={`dashboard-serie-${id}`}>
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="align-self-center">
          <DropdownToggle data-toggle="dropdown" tag="button" className="border-0 bg-transparent">
            <i className={`bi bi-speedometer2 ${isFullDashboard ? "text-success" : "text-dark"} f-s-20`} />
          </DropdownToggle>

          <DropdownMenu className="topbar-dropdown-menu profile-dropdown-items" container=".navbar">
            <div onClick={toggleDropdown}>
              <div
                role="button"
                className={`dropdown-item ${isDashboardReady(DASHBOARD_TYPE.ASCENT_6DOF) ? "text-success" : "text-dark"}`}
                onClick={handleClickAscent}
              >
                <span>{t("list.table.ascending_dashboard")}</span>
              </div>
              <div
                role="button"
                className={`dropdown-item ${isDashboardReady(DASHBOARD_TYPE.DESCENT_6DOF) ? "text-success" : "text-dark"}`}
                onClick={handleClickDescent}
              >
                <span>{t("list.table.descending_dashboard")}</span>
              </div>
              <div
                role="button"
                className={`dropdown-item ${isDashboardReady(DASHBOARD_TYPE.MCS_6DOF_TRIMMING) ? "text-success" : "text-dark"}`}
                onClick={handleClickTrimming}
              >
                <span>{t("list.table.msc_6dof_trimming_dashboard")}</span>
              </div>
              <div
                role="button"
                className={`dropdown-item ${isDashboardReady(DASHBOARD_TYPE.MCS_6DOF_STATISTICAL) ? "text-success" : "text-dark"}`}
                onClick={handleClickStatistical}
              >
                <span>{t("list.table.msc_6dof_statistical_dashboard")}</span>
              </div>
            </div>
          </DropdownMenu>
        </Dropdown>
      </TooltipWrapper>
    )
  ) : null;
};

export default Series6DofMCSDashboard;
